import { render, staticRenderFns } from "./electionVote.vue?vue&type=template&id=2abb850a&scoped=true&"
import script from "./electionVote.vue?vue&type=script&lang=js&"
export * from "./electionVote.vue?vue&type=script&lang=js&"
import style0 from "./electionVote.vue?vue&type=style&index=0&id=2abb850a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb850a",
  null
  
)

export default component.exports